import { EventEmitter } from 'events';

export const eventBus = new EventEmitter()

var albumBucketName = "token-monitor";
var bucketRegion = "us-east-1";

let s3ClientPromise

async function loadS3Client() {
    if (!s3ClientPromise) {
        s3ClientPromise = Promise.all([
            import('aws-sdk/clients/s3'),
            import('aws-sdk/lib/credentials/cognito_identity_credentials'),
        ]).then(([s3Module, credentialsModule]) => {
            const S3 = s3Module.default || s3Module
            const CognitoIdentityCredentials = credentialsModule.default || credentialsModule
            const credentials = new CognitoIdentityCredentials({
                IdentityPoolId: 'us-east-1:9d54ee94-24a7-4c6f-ba16-a35a515b5465',
            })
            return new S3({ region: bucketRegion, credentials })
        })
    }
    return s3ClientPromise
}


// var s3 = new AWS.S3();
export async function AwsUpdate(file, key = '', onProgressCb = null) {
    const s3 = await loadS3Client()
    const upload = s3.upload({
        Bucket: albumBucketName,
        Key: key,
        Body: file
    });

    upload.on('httpUploadProgress', (x) => {
        // const percent = Math.round(x.loaded / x.total * 10000) / 100
        // console.log('上传进度是', percent, "%")
        onProgressCb && onProgressCb(x)
    })

    var promise = upload.promise();
    return promise
}


export const isAddress = (addr) => {
    return /^(0x)?[0-9a-f]{40}$/i.test(addr)
}
